import React, {useMemo, useRef} from 'react'
import Select, {createSelectItem} from "components/Select";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/styles";
import IconButton from "components/button/IconButton";
import ArrowIconLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowIconRight from "@material-ui/icons/KeyboardArrowRight";
import {Paper} from "@material-ui/core";
import Tr from "translations/Translations"
import getObjectValue from "libs/getObjectValue";
import WorkableButton from "components/button/WorkableButton";
import moment from "libs/moment";
import scrollTo from "libs/scrollTo";

const useStyle = makeStyles(theme => ({
    root: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 109
    },
    paper: {
        padding: theme.spacing(0.5),
        border: `solid 2px ${theme.palette.border.dark}`,
    },
    select: {
        minWidth: 550
    },
    margin: {
        margin: `0 ${theme.spacing()}px`
    }
}))

function FormNavigator(
    {
        formikProps,
        id,
        items,
        formTr,
        trPrefix,
        onSubmit,
        onSave,
        onCreateNewVersion,
        buttonWorks,
        doAutoSave = false
    }) {
    const classes = useStyle();
    const editable = getObjectValue('_editable', formikProps.values, true);
    // eslint-disable-next-line
    const memoItems = useMemo(() => items.map((x, i, arr) => createSelectItem(x, `${formTr(trPrefix + x)} (${i + 1}/${arr.length})`)), [items, trPrefix])
    const curStep = formikProps.values[id];
    const curIndex = items.indexOf(curStep);
    const lastSave = useRef(moment())


    const autoSave = () => {
        setTimeout(()=> scrollTo("#form-top-scroll-to", -20), 100)
        if(doAutoSave && onSave) {
            const now = moment();
            if(now.diff(lastSave.current, 'seconds') > 10) {
                onSave();
                lastSave.current = now;
            }
        }
    }

    const onChange = (step) => {
        formikProps.setFieldValue(id, step);
        autoSave();
    }

    return (<div className={classes.root}>
        <Paper className={classes.paper}>
            <GridBlock justify="space-between" alignItems="center" flexGrow>
                <GridBlock justify="center" alignItems="center">
                    <IconButton
                        className={classes.margin}
                        disabled={curIndex < 1}
                        tooltip={curIndex > 0 ? formTr(trPrefix + items[curIndex - 1]) : undefined}
                        variant="outlined"
                        onClick={() => onChange(items[curIndex - 1])}
                        Icon={ArrowIconLeft}/>
                    <Select onChange={autoSave} className={classes.select} items={memoItems} id={id} formikProps={formikProps} noError alwaysEditable/>
                    <IconButton
                        className={classes.margin}
                        disabled={curIndex === items.length - 1}
                        tooltip={curIndex < items.length - 1 ? formTr(trPrefix + items[curIndex + 1]) : undefined}
                        variant="outlined"
                        onClick={() => onChange(items[curIndex + 1])}
                        Icon={ArrowIconRight}/>
                </GridBlock>
                {

                    (!!onCreateNewVersion || !!onSubmit || !!onSave) &&
                    <GridBlock justify="flex-end" alignItems="center">
                        {!!onCreateNewVersion && <WorkableButton working={buttonWorks.newVersion} onClick={onCreateNewVersion}>{Tr('bzp_notice_create_new_version')}</WorkableButton>}
                        {!onCreateNewVersion && !!onSave && <WorkableButton working={buttonWorks.draft} disabled={!editable} variant="outlined" onClick={onSave}>{Tr('save_draft_version')}</WorkableButton>}
                        {!onCreateNewVersion && !!onSubmit && <WorkableButton working={buttonWorks.save} disabled={!editable} onClick={onSubmit} className={classes.margin}>{Tr('save')}</WorkableButton>}
                    </GridBlock>
                }
            </GridBlock>
        </Paper>
    </div>)
}

FormNavigator.propTypes = {};

export default FormNavigator;
